import {Breadcrumb, Col, Row} from "antd";
import React, {useState} from "react";
import KycModal_2 from "../../../pages/accountVerification/view/layout_2/component/kycModal";
import {useRecoilValue} from "recoil";
import {globalBreadCrumbState,} from "../../../_common/global_state";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

export const Breadcrumb_2 = ({kybList, poiList, porList}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const [openKycModal, setOpenKycModal] = useState(false);

    const globalBreadCrumb = useRecoilValue(globalBreadCrumbState);

    const breadcrumbItems = Array.isArray(globalBreadCrumb) && globalBreadCrumb?.length > 0 && globalBreadCrumb?.map((item, index) => ({
        title: (
            <div
                className={"cursor-pointer"}
                style={index === globalBreadCrumb.length - 1 ? {color: localStorage.getItem("color") === "light" ? "var(--brand-300-color)" : "var(--brand-100-color)"} : {color: "var(--primary-text-color)"}}
                onClick={() => navigate(item?.path)}
            >
                {t(`module.${item?.name?.replace(".", "").replace(/[-\s+]/g, "_").toLowerCase()}`)}
            </div>
        ),
    }));

    return (
        <Row>
            <Col span={24} className={"mb-2"}>
                <Breadcrumb
                    className={"mx-auto lg:mx-0 w-fit"}
                    items={breadcrumbItems}
                />
            </Col>
            <KycModal_2
                isModalOpen={openKycModal}
                handleCancel={() => setOpenKycModal(false)}
                verificationType={"kyb"}
                data={kybList}
                poiList={poiList}
                porList={porList}
            />
        </Row>
    );
};
